import type { FC } from 'react'

import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Schedule SVG icon
 */
export const ScheduleSVG: FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG width="100%" height="100%" viewBox="0 0 20 20" {...props}>
    <path
      fill={props.fill}
      d="M19.067 2.468h-4.015V.938a.192.192 0 0 0-.191-.191h-1.339a.192.192 0 0 0-.19.191v1.53h-6.12V.938a.192.192 0 0 0-.19-.191H5.683a.192.192 0 0 0-.191.191v1.53H1.477a.764.764 0 0 0-.765.765v15.87c0 .422.342.764.765.764h17.59a.764.764 0 0 0 .765-.765V3.232a.764.764 0 0 0-.765-.764Zm-.956 15.678H2.433V9.064H18.11v9.082ZM2.433 7.44v-3.25h3.059v1.147c0 .105.086.191.191.191h1.339a.192.192 0 0 0 .19-.191V4.189h6.12v1.147c0 .105.085.191.19.191h1.339a.192.192 0 0 0 .191-.191V4.189h3.06v3.25H2.431Z"
    />
  </AccessibleSVG>
)
